import { uiSelector, setPopups } from "@redux/ui"
import { useDispatch, useSelector } from "react-redux"
import VideoPopup from "./VideoPopup"

interface VideoPopupData {
	id: string
	width: number | string
	height: number | string
	type?: string
}

const PopupsHandler = () => {
	const { popups } = useSelector(uiSelector)
	const dispatch = useDispatch()
	const typedPopups = popups as VideoPopupData[]

	const removePopup = (id: string) => {
		const newPopups = typedPopups.filter((p) => p.id !== id)
		dispatch(setPopups(newPopups))
	}

	return (
		<>
			{typedPopups?.map((p) => (
				<VideoPopup id={p.id} onClose={removePopup} width={p.width} height={p.height} key={p.id} type={p.type} />
			))}
		</>
	)
}

export default PopupsHandler
